import WordmarkLogo from "../../img/DigitalAssets/WordmarkLogo.webp";
import CircleLogo from "../../img/circle-logo.png";
import IconLogo from "../../img/DigitalAssets/IconLogo.webp";
import WordmarkExclusionZone from "../../img/DigitalAssets/WordmarkExclusionZone.webp";
import MVector from "../../img/DigitalAssets/MVector.svg";
import CircleExclusionZone from "../../img/DigitalAssets/CircleExclusionZone.webp";
import RedOnLightGray from "../../img/DigitalAssets/RedOnLightGray.webp";
import RedOnBlack from "../../img/DigitalAssets/RedOnBlack.webp";
import WhiteOnGray from "../../img/DigitalAssets/WhiteOnGray.webp";
import BlackOnPink from "../../img/DigitalAssets/BlackOnPink.webp";
import CircleLogoOnPhoto from "../../img/DigitalAssets/CircleLogoOnPhoto.webp";
import RectLogoOnPhoto from "../../img/DigitalAssets/RectLogoOnPhoto.webp";
import WhiteWordmarkOnPhoto from "../../img/DigitalAssets/WhiteWordmarkOnPhoto.webp";
import CircleLogoOnWhite from "../../img/DigitalAssets/CircleLogoOnWhite.webp";
import WordmarkOnWhite from "../../img/DigitalAssets/WordmarkOnWhite.webp";
import WhiteOnDarkGray from "../../img/DigitalAssets/WhiteOnDarkGray.webp";
import BlackOnLightGray from "../../img/DigitalAssets/BlackOnLightGray.webp";
import TransparentCircleOnPhoto from "../../img/DigitalAssets/TransparentCircleOnPhoto.webp";
import TransparentWhiteOnPhoto from "../../img/DigitalAssets/TransparentWhiteOnPhoto.webp";
import RedOnGray from "../../img/DigitalAssets/RedOnGray.webp";
import RedOnBlackAndWhite from "../../img/DigitalAssets/RedOnBlackAndWhite.webp";
import BlueCircle from "../../img/DigitalAssets/BlueCircle.webp";
import GradientCircle from "../../img/DigitalAssets/GradientCircle.webp";
import PurpleWordmark from "../../img/DigitalAssets/PurpleWordmark.webp";
import GoldGradientWordmark from "../../img/DigitalAssets/GoldGradientWordmark.webp";
import StretchedCircle from "../../img/DigitalAssets/StretchedCircle.webp";
import RotatedCircle from "../../img/DigitalAssets/RotatedCircle.webp";
import StretchedWordmark from "../../img/DigitalAssets/StretchedWordmark.webp";
import RotatedWordmark from "../../img/DigitalAssets/RotatedWordmark.webp";
import { VerticalAlignBottomOutlined } from "@ant-design/icons";
import { Button } from "antd";

export interface DigitalAssetsLogosProps {
  downloadZip: (name: string) => void;
}

export function DigitalAssetsLogos({downloadZip} : DigitalAssetsLogosProps) {
  return (
    <div className={"scroll-area logos"}>
      <div className={"assets-banner mobile-only"}>
        <div>
          <p>Brand Elements</p>
          <div className={"border-el"}/>
          <h1>Logos</h1>
        </div>
      </div>
      <section className={"one"}>
        <h2>Logo Variations</h2>
        <div className={"logos-examples"}>
          <div className={"wordmark"}>
            <img src={WordmarkLogo} alt="Wordmark"/>
            <p>Wordmark Logo</p>
          </div>
          <div className={"circle"}>
            <img src={CircleLogo} alt="Circle"/>
            <p>Circle Logo</p>
          </div>
          <div className={"icon"}>
            <img src={IconLogo} alt="Icon"/>
            <p>Icon Logo</p>
          </div>
        </div>
        <Button className={"mobile-only download-btn"} onClick={() => downloadZip('Logos')}><VerticalAlignBottomOutlined/>Download Logos</Button>
      </section>
      <section className={"two"}>
        <h2>Using our logos</h2>
        <div className={"exclusion"}>
          <p><b>Exclusion Zone</b></p>
          <p>Our logos should always have space to breathe. The exclusion zone is equal to the height of the M in “MUST HAVE.” Please don't put anything in this zone.</p>
          <div className={"vector-holder"}>
            <img src={MVector} alt="Vector"/> = minimum space around logo
          </div>
          <div>
            <img src={WordmarkExclusionZone} alt="Exclusion Zone"/>
            <img src={CircleExclusionZone} alt="Exclusion Zone"/>
          </div>
        </div>
        <div className={"color"}>
          <p><b>Color Usage</b></p>
          <p>Use our full-color, brand red logo whenever possible. In special cases, using the logo in white or black is acceptable.</p>
          <div>
            <div>
              <img src={RedOnLightGray} alt="Red on light gray"/>
              <p>HEX #E42436</p>
            </div>
            <div>
              <img src={RedOnBlack} alt="Red on black"/>
              <p>HEX #E42436</p>
            </div>
            <div>
              <img src={WhiteOnGray} alt="White on gray"/>
              <p>HEX #FFFFFF</p>
            </div>
            <div>
              <img src={BlackOnPink} alt="Black on pink"/>
              <p>HEX #000000</p>
            </div>
          </div>
        </div>
        <div className={"minimum"}>
          <p><b>Minimum Size</b></p>
          <p>The minimum size requirement ensures that our logo is always legible.</p>
          <div className={"logo-sizes"}>
            <div className={"wordmark"}>
              <img src={WordmarkLogo} alt="Wordmark"/>
              <div className={"bracket"}/>
              <p>The wordmark should never be smaller than 100px wide</p>
            </div>
            <div className={"circle"}>
              <img src={CircleLogo} alt="Circle"/>
              <div className={"bracket"}/>
              <p>The circle logo should never be smaller than 100px</p>
            </div>
            <div className={"icon"}>
              <img src={IconLogo} alt="icon"/>
              <div className={"bracket"}/>
              <p>The icon logo should never be smaller than 42px</p>
            </div>
          </div>
        </div>
      </section>
      <section className={"three"}>
        <h2>Logo Do's & Don'ts</h2>
        <p>Our logos should always remain legible and consistent with the guidelines in this document. They should not be modified, distorted, or added to in any way.</p>
        <div className={"mobile-only do-dont-label"}><b>Do's</b></div>
        <div>
          <div className={"do-dont-text"}>
            <p>
              <b>DO</b> use the logos at 100% opacity. You can add a rounded rectangle behind the wordmark logo to increase legibility, as long as the exclusion zone guidelines outlined above are followed.
              <span className={"desktop-only"}>
                <br/><br/>
                <b>DO</b> use our brand red, white or black for the logos.
                <br/><br/>
                <b>DO</b> use the logos in a horizontal orientation, undistorted.
              </span>
            </p>
          </div>
          <div className={"img-flex"}>
            <img className={"wide"} src={CircleLogoOnPhoto} alt="Circle"/>
            <img className={"wide"} src={RectLogoOnPhoto} alt="Rectangle"/>
            <img className={"wide"} src={WhiteWordmarkOnPhoto} alt="White wordmark"/>
            <img className={"desktop-only"} src={CircleLogoOnWhite} alt="Circle on white"/>
            <img className={"desktop-only"} src={WordmarkOnWhite} alt="Wordmark on white"/>
            <img className={"desktop-only"} src={WhiteOnDarkGray} alt="White on dark gray"/>
            <img className={"desktop-only"} src={BlackOnLightGray} alt="Black on light gray"/>
          </div>
          <span className={"mobile-only do-dont-text"}>
            <b>DO</b> use our brand red, white or black for the logos.
            <br/><br/>
            <b>DO</b> use the logos in a horizontal orientation, undistorted.
          </span>
          <div className={"img-flex mobile-only"}>
            <img src={CircleLogoOnWhite} alt="Circle on white"/>
            <img src={WordmarkOnWhite} alt="Wordmark on white"/>
            <img src={WhiteOnDarkGray} alt="White on dark gray"/>
            <img src={BlackOnLightGray} alt="Black on light gray"/>
          </div>
        </div>
        <div className={"mobile-only do-dont-label"}><b>Dont's</b></div>
        <div>
          <div className={"do-dont-text"}>
            <p>
              <b>DON'T</b> change the opacity of the logos or use the logos in a way in which they are not legible.
            </p>
          </div>
          <div className={"img-flex"}>
            <img src={TransparentCircleOnPhoto} alt="Transparent circle"/>
            <img src={TransparentWhiteOnPhoto} alt="Transparent wordmark"/>
            <img src={RedOnGray} alt="Red on gray"/>
            <img src={RedOnBlackAndWhite} alt="Red on black and white"/>
          </div>
        </div>
        <div>
          <div className={"do-dont-text"}>
            <p>
              <b>DON'T</b> change the logo color or apply a gradient to the logos.
            </p>
          </div>
          <div className={"img-flex"}>
            <img src={BlueCircle} alt="Blue circle"/>
            <img src={GradientCircle} alt="Gradient circle"/>
            <img src={PurpleWordmark} alt="Purple wordmark"/>
            <img src={GoldGradientWordmark} alt="Gold gradient wordmark"/>
          </div>
        </div>
        <div>
          <div className={"do-dont-text"}>
            <p>
              <b>DON'T</b> distort or rotate the logos.
            </p>
          </div>
          <div className={"img-flex"}>
            <img src={StretchedCircle} alt="Transparent circle"/>
            <img src={RotatedCircle} alt="Transparent wordmark"/>
            <img src={StretchedWordmark} alt="Red on gray"/>
            <img src={RotatedWordmark} alt="Red on black and white"/>
          </div>
        </div>
      </section>
    </div>
  )
}